import { make } from 'vuex-pathify';
import { EscalationService } from '@/modules/global-settings/delinquency/services/escalation.service';
import Logger from '@/lib/logger.js';

const service = new EscalationService();

const state = {
  efficiencyScoreBands: [],
  escalationTriggerScores: [],
  escalationWarningDays: {}
};

const mutations = make.mutations(state);
const getters = { ...make.getters(state) };

const actions = {
  async getEfficiencyScoreBands({ commit }) {
    try {
      const { data } = await service.getEfficiencyScoreBands();
      commit('SET_EFFICIENCY_SCORE_BANDS', data);
      return data;
    } catch (error) {
      Logger.error('Getting Efficiency Score Bands');
      throw error;
    }
  },

  async createEfficiencyScoreBand(_, payload) {
    try {
      const { data } = await service.createEfficiencyScoreBand(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Efficiency Score Band');
      throw error;
    }
  },

  async updateEfficiencyScoreBand(_, { id, payload }) {
    try {
      const { data } = await service.updateEfficiencyScoreBand({ id, payload });
      return data;
    } catch (error) {
      Logger.error('Updating Efficiency Score Band');
      throw error;
    }
  },

  async removeEfficiencyScoreBand(_, id) {
    try {
      const { data } = await service.removeEfficiencyScoreBand(id);
      return data;
    } catch (error) {
      Logger.error('Removing Efficiency Score Band');
      throw error;
    }
  },

  async getEscalationTriggerScores({ commit }) {
    try {
      const { data } = await service.getEscalationTriggerScores();
      commit('SET_ESCALATION_TRIGGER_SCORES', data);
      return data;
    } catch (error) {
      Logger.error('Getting Escalation Trigger Scores');
      throw error;
    }
  },

  async getPaginatedEscalationTriggerScores(_, params) {
    try {
      const { data } = await service.getPaginatedEscalationTriggerScores(params);
      return data; 
    } catch (error) {
      Logger.error('Getting Paginated Escalation Trigger Scores', error);
      return { data: [], total: 0 }; 
    }
  },

  async createEscalationTriggerScore(_, payload) {
    try {
      const { data } = await service.createEscalationTriggerScore(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Escalation Trigger Score');
      throw error;
    }
  },

  async updateEscalationTriggerScore(_, { id, payload }) {
    try {
      const { data } = await service.updateEscalationTriggerScore({
        id,
        payload
      });
      return data;
    } catch (error) {
      Logger.error('Updating Escalation Trigger Score');
      throw error;
    }
  },

  async removeEscalationTriggerScore(_, id) {
    try {
      const { data } = await service.removeEscalationTriggerScore(id);
      return data;
    } catch (error) {
      Logger.error('Removing Escalation Trigger Score');
      throw error;
    }
  },
  async setAllEscalationActiveStatus(_, { active }) {
    try {
      const { data } = await service.setAllEscalationActiveStatus({ active });
      return data;
    } catch (error) {
      Logger.error('Escalation Trigger Score Status');
      throw error;
    }
  },
  async findEscalationWarningDays({ commit }) {
    try {
      const { data } = await service.findEscalationWarningDays();
      commit('SET_ESCALATION_WARNING_DAYS', data);
      return data;
    } catch (error) {
      Logger.error('Escalation Warning Days');
      throw error;
    }
  },
  async updateEscalationWarningDays({ commit }, payload) {
    try {
      const { data } = await service.updateEscalationWarningDays(payload);
      commit('SET_ESCALATION_WARNING_DAYS', data?.result);
      return data;
    } catch (error) {
      Logger.error('Updating Escalation Warning Days');
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
